import { render, staticRenderFns } from "./enableboard.vue?vue&type=template&id=99de3c30&scoped=true&"
import script from "./enableboard.vue?vue&type=script&lang=js&"
export * from "./enableboard.vue?vue&type=script&lang=js&"
import style0 from "./enableboard.vue?vue&type=style&index=0&id=99de3c30&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99de3c30",
  null
  
)

export default component.exports